'use client';

import { getBasket } from '@/lib/BasketStorage';

import { getBasketEcommerceBody } from '@/lib/GTMEventType';
import { sendGTMEvent } from '@/lib/gtm-wrapper';
import { useEffect } from 'react';

export default function OrderGTMEvent({ event }: { event: string }) {
  useEffect(() => {
    const basket = getBasket();

    if (basket && event !== '') {
      sendGTMEvent({ event, ecommerce: getBasketEcommerceBody(basket) });
    }
  }, [event]);
  return <></>;
}
